import generator from '../util/generator';

export default generator.generate('', 'position', [
    'absolute',
    'relative',
]);
